import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'

export default {

    install (Vue, options) {

        iziToast.settings({
            position: 'bottomCenter',
            progressBar: false,
            timeout: 4000,
            transitionIn: 'fadeIn',
            transitionOut: 'fadeOut',
        });

        Vue.prototype.$numberWithCommas = function (value) {

            var dec = Number(value).toFixed(2);
            var parts = dec.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }

        Vue.prototype.$generalAPIErrorHandling = function (error, router) {

            if (!error.response) {
                this.$networkError();
            } else if (error.response.status == 401) {
                this.$unauthorizedToast(router);
            } else {
                this.$errorToast(error.response.data.error.message);
            }
        }

        Vue.prototype.$errorToast = function (message, title = 'Error') {

            return iziToast.error({
                title: title,
                message: message,
            });
        }

        Vue.prototype.$infoToast = function (message, title = '') {

            return iziToast.info({
                title: title,
                message: message,
            });
        }

        Vue.prototype.$successToast = function (message, title = 'Success') {

            return iziToast.success({
                title: title,
                message: message,
            });
        }

        Vue.prototype.$networkError = function () {

            return iziToast.error({
                title: 'Connection Error',
                message: 'Please try again later.',
            });
        }

        Vue.prototype.$confirmationToast = function (title, message, yesCallback, noCallback) {

            return iziToast.question({
                title: title,
                message: message,
                timeout: null,
                close: false,
                overlay: true,
                overlayClose: false,
                overlayColor: 'rgba(0, 0, 0, 0.6)',
                position: 'center',
                buttons: [
                    ['<button>No</button>', function (instance, toast) {

                        if (noCallback) {
                            noCallback();
                        }

                        instance.hide({
                            transitionOut: 'fadeOut',
                        }, toast, 'buttonName');
                    }, true],
                    ['<button><b>Yes</b></button>', function (instance, toast) {

                        if (yesCallback) {
                            yesCallback();
                        }

                        instance.hide({
                            transitionOut: 'fadeOut',
                        }, toast, 'buttonName');
                    }, true]
                ],
            });
        }

        Vue.prototype.$optionsToast = function (title, message, firstCallback, secondCallback, firstTitle, secondTitle) {

            return iziToast.question({
                title: title,
                message: message,
                timeout: null,
                close: false,
                overlay: true,
                overlayClose: false,
                overlayColor: 'rgba(0, 0, 0, 0.6)',
                position: 'center',
                buttons: [
                    ['<button>' + firstTitle + '</button>', function (instance, toast) {

                        if (secondCallback) {
                            secondCallback();
                        }

                        instance.hide({
                            transitionOut: 'fadeOut',
                        }, toast, 'buttonName');
                    }, true],
                    ['<button><b>' + secondTitle + '</b></button>', function (instance, toast) {

                        if (firstCallback) {
                            firstCallback();
                        }

                        instance.hide({
                            transitionOut: 'fadeOut',
                        }, toast, 'buttonName');
                    }, true]
                ],
            });
        }

        Vue.prototype.$unauthorizedToast = function (router) {

            return iziToast.error({
                title: 'Unauthorized',
                message: 'You have been logged out',
                timeout: null,
                close: false,
                overlay: true,
                overlayClose: false,
                overlayColor: 'rgba(0, 0, 0, 0.6)',
                buttons: [
                    ['<button>Ok</button>', function (instance, toast) {
                        router.push({ name: 'login', params: {} })
                        instance.hide({
                            transitionOut: 'fadeOut',
                        }, toast, 'buttonName');
                    }, true]
                ],
            });
        }
    }
}